<div class="p-3 p-lg-4 contract-shell">
  <div class="d-flex align-items-center gap-3 contract-header">
    <span class="title-badge">
      <lucide-icon [img]="FileTextIcon" [size]="20"></lucide-icon>
    </span>
    <div>
      <h1 class="m-0 contract-title">Contract Wise Analysis Report</h1>
      <div class="analysis-subtitle">Contract Reports with Buy/Sell Analysis</div>
    </div>
  </div>

  @if (estimatedProfitModal(); as modal) {
    <div class="profit-modal-backdrop" (click)="closeEstimatedProfitModal()"></div>
    <div class="profit-modal-card" role="dialog" aria-modal="true" [attr.aria-label]="modal.title + ' details'">
      <div class="profit-modal-head">
        <div>
          <h2 class="profit-modal-title">{{ modal.title }}</h2>
          <div class="profit-modal-subtitle">{{ modal.subtitle }}</div>
        </div>
        <button type="button" class="profit-modal-close" (click)="closeEstimatedProfitModal()">
          <lucide-icon [img]="CloseIcon" [size]="16"></lucide-icon>
        </button>
      </div>
      <div class="profit-modal-body">
        <div class="profit-modal-equation">{{ modal.equation }}</div>
        <div class="profit-modal-hint">{{ modal.hint }}</div>
        <div class="profit-modal-summary">{{ modal.summaryLine }}</div>
        <table class="table table-sm profit-modal-table mb-0">
          <tbody>
            @for (detail of modal.details; track detail.label) {
              <tr>
                <td class="fw-semibold">{{ detail.label }}</td>
                <td>{{ detail.value }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  }

  <div class="pt-3">
    <div class="row g-2 mb-3">
      @for (metric of metrics(); track metric.label) {
        <div class="col-12 col-md-6 col-xl">
          <div class="metric-card h-100 metric-card--simple">
            <div class="metric-head">
              <div class="metric-title-wrap">
                <span class="metric-icon-box">
                  <lucide-icon [img]="metric.icon" [size]="16"></lucide-icon>
                </span>
                <div class="metric-label">{{ metric.label }}</div>
              </div>
              <div class="metric-count" [ngClass]="metric.valueClass">{{ metric.value }}</div>
            </div>
            @if (metric.subValue) {
              <div class="metric-sep"></div>
              <div class="metric-subvalue" [ngClass]="metric.subValueClass">{{ metric.subValue }}</div>
            }
          </div>
        </div>
      }
    </div>

    <div class="content-card p-3 p-lg-4">
      <div class="tool-card mb-3">
        <div class="toolbar-top">
          <div class="filters-grid filters-grid--analysis">
            <div class="field-wrap search-wrap">
              <span class="field-label">Search Contracts</span>
              <div class="search-field-shell">
                <input
                  class="form-control compact-control pe-4"
                  placeholder="Search..."
                  [value]="searchTerm()"
                  (input)="searchTerm.set(($any($event.target).value || '').toString())"
                />
                <lucide-icon [img]="SearchIcon" [size]="16" class="search-icon"></lucide-icon>
              </div>
            </div>
            <div class="field-wrap">
              <span class="field-label">Transaction Type</span>
              <div class="analysis-select-shell">
                <select class="form-select compact-control" [value]="transactionType()" (change)="updateTransactionType(($any($event.target).value || 'all').toString())">
                  <option value="all">All Types</option>
                  <option value="sale_purchase">Sale / Purchase</option>
                  <option value="banking">Banking</option>
                  <option value="hybrid">Hybrid</option>
                </select>
                <lucide-icon class="analysis-chevron" [img]="ChevronDownIcon" [size]="16"></lucide-icon>
              </div>
            </div>

            <div class="filter-buttons">
              <button class="icon-only-btn" type="button" (click)="exportReport()" title="Export">
                <lucide-icon [img]="ExportIcon" [size]="16"></lucide-icon>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="analysis-breakdown-head mb-2">
        <div class="analysis-breakdown-title">Contract - wise Breakdown</div>
        <div class="analysis-breakdown-subtitle">Detailed Analysis by Contract</div>
      </div>

      <div class="table-wrap">
        <div class="table-scroll analysis-table-scroll">
          <table class="table contract-table analysis-table mb-0">
            <thead class="sticky-top">
              <tr>
                <th>S.No.</th>
                <th>Contract ID</th>
                <th>Buyer LOA</th>
                <th>Seller LOA</th>
                <th>Type</th>
                <th>Buyer / Seller</th>
                <th>Requested Quantum</th>
                <th>Total Quantum</th>
                <th>Delivered</th>
                <th>Deviation (%)</th>
                <th>Period</th>
                <th class="profit-col">Estimated Profit</th>
                <th class="profit-col">Actual Profit</th>
                
              </tr>
            </thead>
            <tbody>
              @if (loading()) {
                <tr><td colspan="13" class="text-center py-5 text-muted">Loading report…</td></tr>
              } @else if (loadError()) {
                <tr><td colspan="13" class="text-center py-5 text-danger">{{ loadError() }}</td></tr>
              } @else if (filteredRows().length === 0) {
                <tr><td colspan="13" class="text-center py-5 text-muted">No Records Found</td></tr>
              } @else {
                @for (row of filteredRows(); track row.contractId; let i = $index) {
                  <tr>
                    <td>{{ i + 1 }}</td>
                    <td class="fw-medium">{{ row.contractId }}</td>
                    <td class="text-center">{{ row.buyerLoa }}</td>
                    <td class="text-center">{{ row.sellerLoa }}</td>
                    <td class="text-center"><span class="badge-type">{{ transactionTypeLabel(row.transactionType) }}</span></td>
	                    <td>
	                      <div class="party-stack">
	                        <span class="party buyer">{{ row.buyerName }}</span>
	                        <span class="party seller">{{ row.sellerName }}</span>
	                      </div>
	                    </td>
	                    <td class="text-center fw-semibold">{{ row.totalQuantumMw }} MW</td>
	                    <td
	                      class="text-center fw-semibold"
	                      [attr.title]="'Requested Quantum(MW): ' + row.totalQuantumMw + ', Days Difference: ' + row.daysDifference + ', Time Difference (hours): ' + row.timeDifference"
	                    >
	                      {{ row.totalQuantumMwh }} MWh
	                    </td>
                    <td
                      class="text-center delivered"
                      [attr.title]="'Approved Quantum(MW): ' + row.approvedQuantumMw + ', Days Difference: ' + row.daysDifference + ', Time Difference (hours): ' + row.timeDifference"
                    >
                      {{ row.deliveredMwh }} MWh
                    </td>
                    <td class="text-center">
                      <span class="deviation">{{ row.deviationPercent }}%</span>
                    </td>
                    <td class="text-center">{{ row.periodLabel }}</td>
                    <td class="profit-col text-center">
                      <button
                        type="button"
                        class="profit-trigger"
                        [class]="profitValueClass(estimatedProfitForRow(row))"
                        (click)="openEstimatedProfitModal(row)"
                      >
                        {{ formatProfitValue(estimatedProfitForRow(row)) }}
                      </button>
                    </td>
                    <td class="profit-col text-center">
                      <button
                        type="button"
                        class="profit-trigger"
                        [class]="profitValueClass(actualProfitForRow(row))"
                        (click)="openActualProfitModal(row)"
                      >
                        {{ formatProfitValue(actualProfitForRow(row)) }}
                      </button>
                    </td>
                    
                  </tr>
                }
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
